export class SessionExpiryLabel_EN {
    session: {
        expiry: string;
        network: string;
        loginLink: string;
        loginAgain: string;
        access: string;
        home: string;
        clickHome: string;
        internalServer: string;
        signedOut: string;
        logoutText: string;
        logout: string;
    }

    constructor() {
        this.session = {
            expiry: "Session Expired !",
            access: "Access Restricted !",
            network: "Network Failure !",
            internalServer: "Oops !",
            loginLink: "Click here to login again",
            home: "Go to Home",
            clickHome: "Click here to go home",
            loginAgain: "to login again",
            signedOut: "Signed Out",
            logoutText: "You are now logged out. Any automatic login has also been stopped.",
            logout: "Login Again"
        }
    }
}